module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.title,
      "withBody": _vm.isDisplayDetails || _vm.showCardInfoStatus,
      "withFooter": _vm.isDisplayDetails,
      "to": _vm.getTitleLink(),
      "titleCustomClass": 'l-col-8@md'
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('modal-product-action-reprocess', {
    attrs: {
      "slot": "panel-section",
      "product": _vm.product,
      "typeAction": _vm.typeAction
    },
    on: {
      "confirm": function($event) {
        return _vm.productActionReprocess(_vm.typeAction)
      }
    },
    slot: "panel-section",
    model: {
      value: (_vm.modalProductActionReprocessFlag),
      callback: function($$v) {
        _vm.modalProductActionReprocessFlag = $$v
      },
      expression: "modalProductActionReprocessFlag"
    }
  }), _vm._v(" "), _c('modal-remove-product', {
    attrs: {
      "slot": "panel-section",
      "product": _vm.product,
      "module": _vm.module
    },
    on: {
      "confirm": function($event) {
        return _vm.removeProduct()
      }
    },
    slot: "panel-section",
    model: {
      value: (_vm.modalRemoveProductFlag),
      callback: function($$v) {
        _vm.modalRemoveProductFlag = $$v
      },
      expression: "modalRemoveProductFlag"
    }
  }), _vm._v(" "), _c('modal-deactivate-product', {
    attrs: {
      "slot": "panel-section",
      "product": _vm.product
    },
    on: {
      "confirm": function($event) {
        return _vm.deactivateProduct()
      }
    },
    slot: "panel-section",
    model: {
      value: (_vm.modalDeactivateProductFlag),
      callback: function($$v) {
        _vm.modalDeactivateProductFlag = $$v
      },
      expression: "modalDeactivateProductFlag"
    }
  }), _vm._v(" "), _c('modal-reactivate-product', {
    attrs: {
      "slot": "panel-section",
      "product": _vm.product
    },
    on: {
      "confirm": function($event) {
        return _vm.reactivateProduct()
      }
    },
    slot: "panel-section",
    model: {
      value: (_vm.modalReactivateProductFlag),
      callback: function($$v) {
        _vm.modalReactivateProductFlag = $$v
      },
      expression: "modalReactivateProductFlag"
    }
  }), _vm._v(" "), _c('modal-delete-product', {
    attrs: {
      "slot": "panel-section",
      "product": _vm.product
    },
    on: {
      "confirm": function($event) {
        return _vm.deleteProduct()
      }
    },
    slot: "panel-section",
    model: {
      value: (_vm.modalDeleteProductFlag),
      callback: function($$v) {
        _vm.modalDeleteProductFlag = $$v
      },
      expression: "modalDeleteProductFlag"
    }
  }), _vm._v(" "), _c('modal-resend-product', {
    attrs: {
      "slot": "panel-section",
      "product": _vm.product
    },
    on: {
      "confirm": function($event) {
        return _vm.resendProduct()
      }
    },
    slot: "panel-section",
    model: {
      value: (_vm.modalResendProductFlag),
      callback: function($$v) {
        _vm.modalResendProductFlag = $$v
      },
      expression: "modalResendProductFlag"
    }
  }), _vm._v(" "), _c('modal-reprocess-images', {
    attrs: {
      "slot": "panel-section",
      "product": _vm.product
    },
    on: {
      "confirm": function($event) {
        return _vm.reprocessImages()
      }
    },
    slot: "panel-section",
    model: {
      value: (_vm.modalReprocessImagesFlag),
      callback: function($$v) {
        _vm.modalReprocessImagesFlag = $$v
      },
      expression: "modalReprocessImagesFlag"
    }
  }), _vm._v(" "), (_vm.isDisplayList) ? _c('span', {
    staticClass: "statusDetails status",
    class: _vm.product.saleAvailability
  }, [_vm._v("Disp. de venda")]) : _vm._e(), _vm._v(" "), (_vm.isDisplayList) ? _c('span', {
    staticClass: "statusDetails status hint hint--left",
    class: _vm.product.stock.status,
    attrs: {
      "data-label": _vm.getLastSyncMessage(_vm.product.stock.date)
    }
  }, [_vm._v("Estoque")]) : _vm._e(), _vm._v(" "), (_vm.isDisplayList) ? _c('span', {
    staticClass: "statusDetails status hint hint--left",
    class: _vm.product.price.status,
    attrs: {
      "data-label": _vm.getLastSyncMessage(_vm.product.price.date)
    }
  }, [_vm._v("Preço")]) : _vm._e(), _vm._v(" "), (_vm.isDisplayList && _vm.product.hasOwnProperty('imageStatus')) ? _c('span', {
    staticClass: "statusDetails status",
    class: _vm.product.imageStatus
  }, [_vm._v("Imagem")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "badge statusDetails status hint hint--left",
    class: _vm.product.status,
    attrs: {
      "data-label": _vm.getLastSyncMessage(_vm.product.date)
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$te(((_vm.module.identifier) + ".status." + (_vm.product.status) + ".label")) ? _vm.$t(((_vm.module.identifier) + ".status." + (_vm.product.status) + ".label")) : _vm.$t(((_vm.product.status) + ".label"))) + "\n    ")]), _vm._v(" "), _c('button-actions', {
    attrs: {
      "identifier": ("product-item-actions-" + (_vm.product._id.$oid))
    }
  }, [(_vm.getTitleLink()) ? _c('li', [_c('router-link', {
    attrs: {
      "to": _vm.getTitleLink()
    }
  }, [_vm._v("Editar")])], 1) : _vm._e(), _vm._v(" "), (_vm.product.message || _vm.product.price.message || _vm.product.stock.message || _vm.product.imageErrorMessage || _vm.product.imageStatusMessage) ? _c('li', [_c('span', {
    on: {
      "click": _vm.showInfoStatusMessage
    }
  }, [_vm._v("Ver mensagens")])]) : _vm._e(), _vm._v(" "), (_vm.product.salesChannel !== undefined && _vm.product.salesChannel.length) ? _c('li', [_c('span', {
    on: {
      "click": _vm.showSaleChannelPriceModal
    }
  }, [_vm._v("Preços por canal de venda")]), _vm._v(" "), _c('modal-sales-channel-price', {
    attrs: {
      "salesChannel": _vm.product.salesChannel
    },
    model: {
      value: (_vm.saleChannelPriceModal),
      callback: function($$v) {
        _vm.saleChannelPriceModal = $$v
      },
      expression: "saleChannelPriceModal"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.product.status === 'approved' && (this.module.identifier === 'gfg' || this.module.identifier === 'amazon')) ? _c('li', [_c('span', {
    on: {
      "click": function($event) {
        _vm.modalProductActionReprocessFlag = true, _vm.typeAction = 'product'
      }
    }
  }, [_vm._v("Reprocessar produto")])]) : _vm._e(), _vm._v(" "), (_vm.product.status === 'approved') ? _c('li', [_c('span', {
    on: {
      "click": function($event) {
        _vm.modalProductActionReprocessFlag = true, _vm.typeAction = 'stock'
      }
    }
  }, [_vm._v("Reprocessar estoque")])]) : _vm._e(), _vm._v(" "), (_vm.product.status === 'approved') ? _c('li', [_c('span', {
    on: {
      "click": function($event) {
        _vm.modalProductActionReprocessFlag = true, _vm.typeAction = 'price'
      }
    }
  }, [_vm._v("Reprocessar preço")])]) : _vm._e(), _vm._v(" "), (_vm.product.status === 'approved') ? _c('li', [_c('span', {
    on: {
      "click": function($event) {
        _vm.modalReprocessImagesFlag = true
      }
    }
  }, [_vm._v("Reprocessar imagem")])]) : _vm._e(), _vm._v(" "), ((_vm.product.status !== 'error' && this.module.identifier !== 'cnova') || (this.module.identifier === 'cnova' && _vm.product.status === 'approved' && _vm.product.saleAvailability === 'available')) ? _c('li', [_c('span', {
    on: {
      "click": function($event) {
        _vm.modalDeactivateProductFlag = true
      }
    }
  }, [_vm._v("Indisponibilizar produto")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    on: {
      "click": function($event) {
        _vm.modalRemoveProductFlag = true
      }
    }
  }, [_vm._v("Remover produto")])]), _vm._v(" "), (this.module.identifier === 'cnova' && _vm.product.status !== 'error' && _vm.product.saleAvailability !== 'available') ? _c('li', [_c('span', {
    on: {
      "click": function($event) {
        _vm.modalReactivateProductFlag = true
      }
    }
  }, [_vm._v("Reativar produto")])]) : _vm._e(), _vm._v(" "), (this.module.identifier === 'cnova' && (_vm.product.status === 'approved' || _vm.product.status === 'denied')) ? _c('li', [_c('span', {
    on: {
      "click": function($event) {
        _vm.modalDeleteProductFlag = true
      }
    }
  }, [_vm._v("Excluir produto")])]) : _vm._e(), _vm._v(" "), (this.module.identifier === 'shopee' && _vm.product.status === 'deleted') ? _c('li', [_c('span', {
    on: {
      "click": function($event) {
        _vm.modalResendProductFlag = true
      }
    }
  }, [_vm._v("Reenviar produto")])]) : _vm._e()])], 1), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCard),
      expression: "showCard"
    }],
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-2@md img-product"
  }, [(_vm.image) ? _c('img', {
    staticClass: "img-rounded",
    attrs: {
      "src": _vm.image
    }
  }) : _c('i', {
    staticClass: "icon icon-image2 no-photo"
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "l-col-3@md box"
  }, [_c('div', {
    staticClass: "l-row attributes"
  }, [_c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v("SKU")]), _vm._v("\n                " + _vm._s(_vm._f("attribute")(_vm.product.sku)) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v("EAN")]), _vm._v("\n                " + _vm._s(_vm._f("attribute")(_vm.product.ean)) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v("Marca")]), _vm._v("\n                " + _vm._s(_vm._f("attribute")(_vm.product.brand)) + "\n              ")])]), _vm._v(" "), (_vm.product.productId) ? _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('productGroupedId.label')))]), _vm._v("\n                " + _vm._s(_vm._f("attribute")(_vm.product.productId)) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('createdAt.label')))]), _vm._v("\n                " + _vm._s(_vm._f("attribute")(_vm._f("moment")(_vm.product.createdAt, 'DD/MM/YYYY HH:mm'))) + "\n              ")]), _vm._v(" "), (_vm.product.account) ? _c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v("Conta")]), _vm._v("\n                " + _vm._s(_vm.product.account.identifier) + "\n              ")]) : _vm._e()]), _vm._v(" "), _vm._t("attributes")], 2)]), _vm._v(" "), _vm._t("custom-column"), _vm._v(" "), _c('blockquote', {
    staticClass: "l-col-2@md box"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-6@md attributes"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('stock.label')))]), _vm._v("\n                " + _vm._s(_vm._f("attribute")(_vm.product.stock.quantity)) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('reducer.label')))]), _vm._v("\n                " + _vm._s(_vm._f("attribute")(_vm.product.stock.reducer)) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v("Status Estoque")]), _vm._v(" "), _c('span', {
    staticClass: "status hint hint--left",
    class: _vm.product.stock.status,
    attrs: {
      "data-label": _vm.getLastSyncMessage(_vm.product.stock.date)
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.product.stock.status).label))])]), _vm._v(" "), _c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v("Disp. de venda")]), _vm._v(" "), _c('span', {
    staticClass: "status",
    class: _vm.product.saleAvailability
  }, [_vm._v(_vm._s(_vm.$t(("saleAvailability." + (_vm.product.saleAvailability) + ".label"))))])])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "l-col-3@md box"
  }, [_c('div', {
    staticClass: "l-row vertical-flex"
  }, [_c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('type.label')))]), _vm._v("\n                " + _vm._s(_vm.$t(_vm.product.price.type).label) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('price.previous.label')))]), _vm._v("\n                " + _vm._s(_vm._f("currency")(_vm.product.price.previous)) + "\n              ")]), _vm._v(" "), (_vm.isMarginPriceType) ? _c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t(("price." + (_vm.product.price.type) + ".auxiliary.label"))))]), _vm._v(" "), (!_vm.isMarginPriceType) ? _c('span', [_vm._v(_vm._s(_vm.product.price.auxiliary))]) : _c('editable', {
    attrs: {
      "label": _vm.$t(("price." + (_vm.product.price.type) + ".auxiliary.label")),
      "type": _vm.product.price.type === 'percent' ? 'percent' : 'price',
      "onConfirm": _vm.confirmedUpdateAuxiliary
    },
    model: {
      value: (_vm.product.price.auxiliary),
      callback: function($$v) {
        _vm.$set(_vm.product.price, "auxiliary", $$v)
      },
      expression: "product.price.auxiliary"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v("Status Preço")]), _vm._v(" "), _c('span', {
    staticClass: "status hint hint--left",
    class: ( _obj = {}, _obj[_vm.product.price.status] = true, _obj['margin-price'] =  _vm.isMarginPriceType, _obj ),
    attrs: {
      "data-label": _vm.getLastSyncMessage(_vm.product.price.date)
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.product.price.status).label) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('price.current.label')))]), _vm._v(" "), (!_vm.isAllowUpdatePrice) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.product.price.current)))]) : _c('editable', {
    attrs: {
      "label": _vm.$t('price.current.label'),
      "type": "price",
      "onConfirm": _vm.confirmedUpdatePrice
    },
    model: {
      value: (_vm.product.price.current),
      callback: function($$v) {
        _vm.$set(_vm.product.price, "current", $$v)
      },
      expression: "product.price.current"
    }
  })], 1)])])])], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showCardInfoStatus) ? _c('status-message-card', {
    attrs: {
      "product": _vm.product,
      "module": _vm.module
    },
    on: {
      "close": function($event) {
        return _vm.showInfoStatusMessage()
      }
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('module-icon', {
    attrs: {
      "identifier": _vm.product.source.identifier
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f65ec3b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shared/ProductCard.vue
// module id = 2965
// module chunks = 0